import { inject } from 'vue'

export function useCookieConsent() {
  const CookieConsent = inject('CookieConsent')

  if (!CookieConsent) {
    throw new Error('CookieConsent plugin is not properly injected.')
  }

  return CookieConsent
}
